import { uniq } from '@/common/utils/array.utils';
import { defineStore } from 'pinia';
import { LoaderState } from '@/types/utils/loader.types';

export const useLoaderStore = defineStore('loader', {
  state: (): LoaderState => ({
    activeLoaders: [],
    isLoading: false,
    isBOQLoading: false,
  }),

  getters: {
    getLoaderByName: (state) => {
      return (loaderName: string): boolean =>
        !!state.activeLoaders.find((loader: string) => loader === loaderName);
    },

    /**
     * Whether the BOQ grid should show its skeleton: a `boq-grid` request, or `BoqLayout` holding
     * `boq-grid-mount` from mount until its first BOQ and cart requests settle. The hold needs a
     * name of its own because loaders are unique by name — the first `boq-grid` request to settle
     * would otherwise end it, and the grid would flash between that request and the cart's.
     */
    isBoqGridLoading: (state): boolean =>
      state.activeLoaders.includes('boq-grid') || state.activeLoaders.includes('boq-grid-mount'),
  },

  actions: {
    start(loaderName: string) {
      this.activeLoaders.push(loaderName);
      this.activeLoaders = uniq(this.activeLoaders);
      this.updateIsLoading();
    },

    end(loaderName: string) {
      this.activeLoaders = uniq(this.activeLoaders).filter((p) => p !== loaderName);
      this.updateIsLoading();
    },

    endAll() {
      this.activeLoaders = [];
      this.updateIsLoading();
    },

    setBOQLoader(loading: boolean) {
      this.isBOQLoading = loading;
    },

    updateIsLoading() {
      this.isLoading =
        this.activeLoaders.length > 0 && !this.activeLoaders.includes('document-upload');
    },
  },
});
